import {ValueObject} from '@s-ui/domain'

export class CalculatorPluginTransactionsValueObject extends ValueObject {
  /**
   * @param {Object} data
   * @param {String} data.url
   * @param {String} data.widgetType
   */
}
